import KImage from '@/types/KImage'

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export interface Discount {
  htmlContent: string,
  iconUrl: string
}

class DiscountsSection {
  private json: any
  public readonly uid: string;
  public readonly title: string;
  public readonly description: string;
  public readonly discounts: Array<Discount>;
  public readonly icon: KImage;

  constructor (json: any) {
    this.json = json
    this.uid = json.uid
    this.title = json.heading
    this.description = json.description
    this.icon = new KImage(
      json.savings_icon.url,
      json.savings_icon.content_type,
      json.icon_alt_text
    )
    this.discounts = json.saving_offers?.map((discount: any) => {
      return {
        htmlContent: discount.free_text,
        iconUrl: discount.icon.url
      }
    })
  }

  static of (json: any): DiscountsSection {
    return new DiscountsSection(json)
  }
}

export default DiscountsSection
